import { Directive, HostListener, Input, ElementRef, Output, EventEmitter } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appDosePattern]'
})
export class DosePatternDirective {

  @Input() times: number = 4;
  @Output() suggestionsChange = new EventEmitter<string[]>();

  constructor(private control: NgControl, private el: ElementRef<HTMLInputElement>) { }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = this.el.nativeElement.value;
    const inputParts = input.split('-');

    // Validate only length
    const isValid = inputParts.length === this.times;
    this.control.control?.setErrors(isValid ? null : { invalidPattern: true });

    // Generate dynamic suggestions
    const suggestions = this.generateDosePatterns(this.times, inputParts);
    this.suggestionsChange.emit(suggestions);
  }

  private getAllowedValues(inputParts: string[]): string[] {
    const base = ['0', '½', '1', '2'];
    const dynamic = new Set(base);

    inputParts.forEach(p => {
      if (p && !isNaN(Number(p))) {
        dynamic.add(p);   // user-typed number
      }
    });

    return Array.from(dynamic);
  }

  private generateDosePatterns(times: number, inputParts: string[]): string[] {
    const patterns: string[] = [];
    const allowed = this.getAllowedValues(inputParts);

    const generate = (index: number, current: string[]) => {
      if (index === times) {
        const pattern = current.join('-');

        if (pattern.startsWith(inputParts[0])) {
          patterns.push(pattern);
        }
        return;
      }

      if (inputParts[index]) {
        generate(index + 1, [...current, inputParts[index]]);
      } else {
        for (let v of allowed) {
          generate(index + 1, [...current, v]);
        }
      }
    };

    generate(0, []);
    const typed = inputParts[0];

    return patterns.sort((a, b) => {
      const countA = a.split('-').filter(x => x === typed).length;
      const countB = b.split('-').filter(x => x === typed).length;
      if (countB !== countA) return countB - countA;
      return a.localeCompare(b);
    });
  }
}
